<div class="oben">

    <div class="ebeneHead">
        <p class="elementHead">{{'fitments'| translate}}</p>
    </div>

    @if (fitted?.length > 0) {
    <div class="container-fluid">
        <dl class="row">
            <dt class="col-sm-3">{{'MaterialNumberShort' | translate}}</dt>
            <dd class="col-sm-9"><strong>{{'MaterialShortDescription' | translate}}</strong></dd>
            @for (zmaterial of fitted; track zmaterial) {
            <dt class="col-sm-3">{{ zmaterial.matnr }}</dt>
            <dd class="col-sm-9">{{ zmaterial.maktx }}</dd>
            }
        </dl>
    </div>
    }

    @if (optional?.length > 0) {
    <div class="container-fluid">
        <div class="ebeneHead">
            <p class="elementHead">{{'OptionalEquipment' | translate}}</p>
        </div>
        <dl class="row">
            <dt class="col-sm-3">{{'MaterialNumberShort' | translate}}</dt>
            <dd class="col-sm-9"><strong>{{'MaterialShortDescription' | translate}}</strong></dd>
            @for (zmaterial of optional; track zmaterial) {
            <dt class="col-sm-3">{{ zmaterial.matnr }}</dt>
            <dd class="col-sm-9" [innerHTML]="zmaterial.maktx"></dd>
            }
        </dl>
    </div>
    }

</div>